const useError = (errores, name) => {
  const error = errores && errores[name]

  const ShowError = () => {
    if (error) {
      return (
        <div className="alert alert-danger mt-1" role="alert">
          {error}
        </div>
      )
    } else {
      return <></>
    }
  }

  return { ShowError, hayError: error !== undefined }
}

export default useError
